import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

import { ZoneSelectService } from '../../../services/selects/zone-select.service';
import { StateSelectService } from '../../../services/selects/state-select.service';
import { BusinesstypeSelectService } from '../../../services/selects/businesstype-select.service';
import { WorkReqSelectService } from '../../../services/selects/workreq-select.service';

import { ZoneSelModel } from '../../../models/selects/zone.sel.model';
import { StateSelModel } from '../../../models/selects/state.sel.model';
import { BusinessTypeSelModel } from '../../../models/selects/businesstype.sel.model';
import { WorkReqSelModel } from '../../../models/selects/workreq.sel.model';
import { CitySelModel } from '../../../models/selects/city.sel.model';
import { CitySelectService } from '../../../services/selects/city-select.service';
import { RequesterRoleSelectService } from '../../../services/selects/requester-role-select.service';
import { RequesterRoleSelModel } from '../../../models/selects/requester-role.sel.model';
import { TankSizeSelectService } from '../../../services/selects/tank-size-select.service';
import { TankSizeSelModel } from '../../../models/selects/tank-size.sel.model';

@Component({
  selector: 'app-selects',
  templateUrl: './selects.component.html',
  styleUrls: ['./selects.component.scss'],
  standalone: false
})
export class SelectsComponent implements OnInit {


  zoneSelForm: UntypedFormGroup;
  stateSelForm: UntypedFormGroup;
  businessTypeSelForm: UntypedFormGroup;
  workReqSelForm: UntypedFormGroup;
  citySelForm: UntypedFormGroup;
  requesterRoleSelForm: UntypedFormGroup;
  tankSizeSelForm: UntypedFormGroup;

  zonessel: ZoneSelModel[] = [];
  statessel: StateSelModel[] = [];
  businessTypessel: BusinessTypeSelModel[] = [];
  workreqsel: WorkReqSelModel[] = [];
  citysel: CitySelModel[] = [];
  requesterRolessel: RequesterRoleSelModel[] = [];
  tankSizessel: TankSizeSelModel[] = [];

  loadingZone: boolean = true;
  loadingState: boolean = true;
  loadingBusinessType: boolean = true;
  loadingWorkreq: boolean = true;
  loadingCity: boolean = true;
  loadingRequesterRole: boolean = true;
  loadingTankSize: boolean = true;

  // Accordion state tracking
  activeSections: Set<string> = new Set(['areas', 'businessTypes', 'requesterRoles']);

  toggleSection(sectionKey: string): void {
    if (this.activeSections.has(sectionKey)) {
      this.activeSections.delete(sectionKey);
    } else {
      this.activeSections.add(sectionKey);
    }
  }

  isExpanded(sectionKey: string): boolean {
    return this.activeSections.has(sectionKey);
  }

  expandAll(): void {
    ['areas', 'states', 'cities', 'businessTypes', 'workRequests', 'requesterRoles', 'tankSizes'].forEach(key => this.activeSections.add(key));
  }

  collapseAll(): void {
    this.activeSections.clear();
  }

  constructor(private fb: UntypedFormBuilder,
    private toastr: ToastrService,
    private zoneSelectService: ZoneSelectService,
    private stateSelectService: StateSelectService,
    private businesstypeSelectService: BusinesstypeSelectService,
    private workReqSelectService: WorkReqSelectService,
    private citySelectService: CitySelectService,
    private requesterRoleSelectService: RequesterRoleSelectService,
    private tankSizeSelectService: TankSizeSelectService
  ) { }

  ngOnInit(): void {

    this.cargarData();
    this.crearFormularios();

  }

  async cargarData() {


    this.zonessel = await this.zoneSelectService.getAllAsync().then(({ zonesel }) => zonesel)
      .catch(err => []);
    console.log('Zones ', this.zonessel);


    this.statessel = await this.stateSelectService.getAllAsync().then(({ statesel }) => statesel)
      .catch(err => []);

    console.log('States ', this.statessel);

    this.businessTypessel = await this.businesstypeSelectService.getAllAsync().then(({ businesstypesel }) => businesstypesel)
      .catch(err => []);

    console.log('Business ', this.businessTypessel);

    this.workreqsel = await this.workReqSelectService.getAllAsync().then(({ workreqsel }) => workreqsel)
      .catch(err => []);

    console.log('Work Req ', this.workreqsel);

    this.citysel = await this.citySelectService.getAllAsync().then(({ citysel }) => citysel)
      .catch(err => []);

    console.log('Cities ', this.citysel);

    this.requesterRolessel = await this.requesterRoleSelectService.getAllAsync().then(({ requesterrolesel }) => requesterrolesel)
      .catch(err => []);

    this.tankSizessel = await this.tankSizeSelectService.getAllAsync().then(({ tanksizesel }) => tanksizesel)
      .catch(err => []);

    console.log('Tank Sizes ', this.tankSizessel);

    setTimeout(() => {
      this.loadingZone = false;
      this.loadingState = false;
      this.loadingBusinessType = false;
      this.loadingWorkreq = false;
      this.loadingCity = false;
      this.loadingRequesterRole = false;
      this.loadingTankSize = false;
    }, 5);

  }



  get zoneNameNoValido() {
    return this.zoneSelForm.get('name').invalid && this.zoneSelForm.get('name').touched;
  }
  get stateNameNoValido() {
    return this.stateSelForm.get('name').invalid && this.stateSelForm.get('name').touched;
  }
  get businessTypeNameNoValido() {
    return this.businessTypeSelForm.get('name').invalid && this.businessTypeSelForm.get('name').touched;
  }
  get workReqNameNoValido() {
    return this.workReqSelForm.get('name').invalid && this.workReqSelForm.get('name').touched;
  }
  get cityNameNoValido() {
    return this.citySelForm.get('name').invalid && this.citySelForm.get('name').touched;
  }
  get requesterRoleNameNoValido() {
    return this.requesterRoleSelForm.get('name').invalid && this.requesterRoleSelForm.get('name').touched;
  }
  get tankSizeNameNoValido() {
    return this.tankSizeSelForm.get('name').invalid && this.tankSizeSelForm.get('name').touched;
  }


  crearFormularios() {

    this.zoneSelForm = this.fb.group({

      name: ['', [Validators.required, Validators.minLength(1)]],

    });


    this.stateSelForm = this.fb.group({

      name: ['', [Validators.required, Validators.minLength(1)]],

    });


    this.businessTypeSelForm = this.fb.group({

      name: ['', [Validators.required, Validators.minLength(1)]],

    });

    this.workReqSelForm = this.fb.group({

      name: ['', [Validators.required, Validators.minLength(1)]],

    });
    this.citySelForm = this.fb.group({

      name: ['', [Validators.required, Validators.minLength(1)]],

    });

    this.requesterRoleSelForm = this.fb.group({

      name: ['', [Validators.required, Validators.minLength(1)]],

    });

    this.tankSizeSelForm = this.fb.group({

      name: ['', [Validators.required, Validators.minLength(1)]],

    });



  }


  newZoneSel() {

    if (this.zoneSelForm.invalid) {
      return Object.values(this.zoneSelForm.controls).forEach(control => {
        control.markAsTouched();
      });
    }

    this.zonessel = [];
    this.loadingZone = true;

    this.zoneSelectService.create(this.zoneSelForm.value)
      .subscribe(async resp => {
        const _zonessel = await this.zoneSelectService.getAllAsync()
          .then(({ zonesel }) => zonesel)
          .catch(errr => []);
        this.zoneSelForm.reset();
        setTimeout(() => {
          this.zonessel = _zonessel
          this.loadingZone = false;

        }, 200);
      });


  }


  newStateSel() {

    if (this.stateSelForm.invalid) {
      return Object.values(this.stateSelForm.controls).forEach(control => {
        control.markAsTouched();
      });
    }

    this.statessel = [];
    this.loadingState = true;

    this.stateSelectService.create(this.stateSelForm.value)
      .subscribe(async resp => {
        const _statessel = await this.stateSelectService.getAllAsync()
          .then(({ statesel }) => statesel)
          .catch(errr => []);

        this.stateSelForm.reset();
        setTimeout(() => {
          this.statessel = _statessel
          this.loadingState = false;

        }, 200);
      });


  }

  newBusinessTypeSel() {

    if (this.businessTypeSelForm.invalid) {
      return Object.values(this.businessTypeSelForm.controls).forEach(control => {
        control.markAsTouched();
      });
    }


    this.businessTypessel = [];
    this.loadingBusinessType = true;

    this.businesstypeSelectService.create(this.businessTypeSelForm.value)
      .subscribe(async resp => {
        const _businessTypessel = await this.businesstypeSelectService.getAllAsync()
          .then(({ businesstypesel }) => businesstypesel)
          .catch(errr => []);

        this.businessTypeSelForm.reset();
        setTimeout(() => {
          this.businessTypessel = _businessTypessel
          this.loadingBusinessType = false;

        }, 200);
      });




  }


  newWorkReqSel() {

    if (this.workReqSelForm.invalid) {
      return Object.values(this.workReqSelForm.controls).forEach(control => {
        control.markAsTouched();
      });
    }


    this.workreqsel = [];
    this.loadingWorkreq = true;

    this.workReqSelectService.create(this.workReqSelForm.value)
      .subscribe(async resp => {
        const _workreqsel = await this.workReqSelectService.getAllAsync()
          .then(({ workreqsel }) => workreqsel)
          .catch(errr => []);

        this.workReqSelForm.reset();
        setTimeout(() => {
          this.workreqsel = _workreqsel
          this.loadingWorkreq = false;

        }, 200);
      });




  }

  newCitySel() {

    if (this.citySelForm.invalid) {
      return Object.values(this.citySelForm.controls).forEach(control => {
        control.markAsTouched();
      });
    }


    this.citysel = [];
    this.loadingCity = true;

    this.citySelectService.create(this.citySelForm.value)
      .subscribe(async resp => {
        const _citysel = await this.citySelectService.getAllAsync()
          .then(({ citysel }) => citysel)
          .catch(errr => []);

        this.citySelForm.reset();
        setTimeout(() => {
          this.citysel = _citysel
          this.loadingCity = false;

        }, 200);
      });




  }


  deleteZoneSel(item) {

    this.zoneSelectService.delete(item._id).subscribe(async resp => {

      this.toastr.info(resp.msg);

      this.zonessel = await this.zoneSelectService.getAllAsync()
        .then(({ zonesel }) => zonesel)
        .catch(errr => []);
    }, (error) => {
      console.log(error);
      let _error = 'Error'
      if (error.error.msg) {
        _error = error.error.msg;
      }
      this.toastr.error(_error);

    });

  }

  deleteStateSel(item) {

    this.stateSelectService.delete(item._id).subscribe(async resp => {

      this.toastr.info(resp.msg);

      this.statessel = await this.stateSelectService.getAllAsync()
        .then(({ statesel }) => statesel)
        .catch(errr => []);
    }, (error) => {
      console.log(error);
      let _error = 'Error'
      if (error.error.msg) {
        _error = error.error.msg;
      }
      this.toastr.error(_error);

    });

  }


  deleteBusinessTypeSel(item) {

    this.businesstypeSelectService.delete(item._id).subscribe(async resp => {

      this.toastr.info(resp.msg);

      this.businessTypessel = await this.businesstypeSelectService.getAllAsync()
        .then(({ businesstypesel }) => businesstypesel)
        .catch(errr => []);
    }, (error) => {
      console.log(error);
      let _error = 'Error'
      if (error.error.msg) {
        _error = error.error.msg;
      }
      this.toastr.error(_error);

    });

  }

  deleteWorkReqSel(item) {

    this.workReqSelectService.delete(item._id).subscribe(async resp => {

      this.toastr.info(resp.msg);

      this.workreqsel = await this.workReqSelectService.getAllAsync()
        .then(({ workreqsel }) => workreqsel)
        .catch(errr => []);
    }, (error) => {
      console.log(error);
      let _error = 'Error'
      if (error.error.msg) {
        _error = error.error.msg;
      }
      this.toastr.error(_error);

    });

  }
  deleteCitySel(item) {

    this.citySelectService.delete(item._id).subscribe(async resp => {

      this.toastr.info(resp.msg);

      this.citysel = await this.citySelectService.getAllAsync()
        .then(({ citysel }) => citysel)
        .catch(errr => []);
    }, (error) => {
      console.log(error);
      let _error = 'Error'
      if (error.error.msg) {
        _error = error.error.msg;
      }
      this.toastr.error(_error);

    });

  }

  newRequesterRoleSel() {

    if (this.requesterRoleSelForm.invalid) {
      return Object.values(this.requesterRoleSelForm.controls).forEach(control => {
        control.markAsTouched();
      });
    }

    this.requesterRolessel = [];
    this.loadingRequesterRole = true;

    this.requesterRoleSelectService.create(this.requesterRoleSelForm.value)
      .subscribe(async resp => {
        const _requesterRolessel = await this.requesterRoleSelectService.getAllAsync()
          .then(({ requesterrolesel }) => requesterrolesel)
          .catch(errr => []);

        this.requesterRoleSelForm.reset();
        setTimeout(() => {
          this.requesterRolessel = _requesterRolessel;
          this.loadingRequesterRole = false;

        }, 200);
      });




  }

  deleteRequesterRoleSel(item) {

    this.requesterRoleSelectService.delete(item._id).subscribe(async resp => {

      this.toastr.info(resp.msg);

      this.requesterRolessel = await this.requesterRoleSelectService.getAllAsync()
        .then(({ requesterrolesel }) => requesterrolesel)
        .catch(errr => []);
    }, (error) => {
      console.log(error);
      let _error = 'Error'
      if (error.error.msg) {
        _error = error.error.msg;
      }
      this.toastr.error(_error);

    });

  }

  newTankSizeSel() {

    if (this.tankSizeSelForm.invalid) {
      return Object.values(this.tankSizeSelForm.controls).forEach(control => {
        control.markAsTouched();
      });
    }

    this.tankSizessel = [];
    this.loadingTankSize = true;

    this.tankSizeSelectService.create(this.tankSizeSelForm.value)
      .subscribe(async resp => {
        const _tankSizessel = await this.tankSizeSelectService.getAllAsync()
          .then(({ tanksizesel }) => tanksizesel)
          .catch(errr => []);

        this.tankSizeSelForm.reset();
        setTimeout(() => {
          this.tankSizessel = _tankSizessel;
          this.loadingTankSize = false;
        }, 200);
      });
  }

  deleteTankSizeSel(item) {

    this.tankSizeSelectService.delete(item._id).subscribe(async resp => {

      this.toastr.info(resp.msg);

      this.tankSizessel = await this.tankSizeSelectService.getAllAsync()
        .then(({ tanksizesel }) => tanksizesel)
        .catch(errr => []);
    }, (error) => {
      console.log(error);
      let _error = 'Error';
      if (error.error.msg) {
        _error = error.error.msg;
      }
      this.toastr.error(_error);
    });
  }
}
